"use client";
import { createMakeStyles } from "tss-react";
import { useTheme as useThemeContext } from "./theme-provider.js";
function useTheme() {
    const { theme } = useThemeContext();
    return theme;
}
export const { makeStyles, useStyles } = createMakeStyles({ useTheme });
export function useCx() {
    const { cx } = useStyles();
    return cx;
}
export default makeStyles;
//# sourceMappingURL=make-styles.js.map